import { render, staticRenderFns } from "./UpdateRequestInfo.vue?vue&type=template&id=ca3ba2e0&"
import script from "./UpdateRequestInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports